<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>{{ grade ? `حجوزات ${grade.name}` : 'جدول الطلاب' }} ({{ pagination }})</h4>
        <div class="buttons">
          <BulkSms v-if="grade?.id" :academic_year_id="grade.id" />
          <button v-if="grade?.id" type="button" class="btn btn-success" @click="openBulkStatusDialog">
            تغيير حالة الحجوزات
          </button>
          <button type="button" class="btn btn-warning text-white" :disabled="selectedIds.length === 0" @click="openTransferDialog">
            <i class="pi pi-arrow-right-arrow-left me-1"></i> نقل الطلاب{{ selectedIds.length ? ` (${selectedIds.length})` : '' }}
          </button>
          <router-link :to="`/grades/${gradeSlug}/attendance`" class="btn PrimaryButton">الغياب</router-link>
          <router-link :to="`/grades/${gradeSlug}/absence`" class="btn PrimaryButton">شيت الدفع</router-link>
          <router-link :to="`/grades/${gradeSlug}/students/barcodes`" class="btn btn-outline-primary">
            <i class="pi pi-barcode me-1"></i> باركود الطلاب
          </router-link>
          <router-link :to="`/grades/${gradeSlug}/students/add`" class="btn PrimaryButton">إضافة حجز</router-link>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-12 col-12">
          <div class="form-group">
            <label>ابحث</label>
            <input type="search" class="form-control" placeholder="ابحث" v-model="word" @keyup="debounceFetch">
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>نوع الطالب</label>
            <Dropdown v-model="student_type" :options="studentTypeList" showClear optionLabel="title" placeholder="نوع الطالب" @change="onFilterChange" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="d-flex form-group gap-1">
            <div class="d-flex flex-column flex-fill">
              <label for="min_degree">من</label>
              <input type="number" id="min_degree" class="form-control" placeholder="من" v-model="min_degree"
                     step="0.01" @input="debounceFetchByDegree">
            </div>
            <div class="d-flex flex-column flex-fill">
              <label for="max_degree">إلى</label>
              <input type="number" id="max_degree" class="form-control" placeholder="إلى" v-model="max_degree"
                     step="0.01" @input="debounceFetchByDegree">
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>حالة الحجز</label>
            <Dropdown v-model="status" :options="statusList" showClear optionLabel="title" placeholder="حالة الحجز" @change="onFilterChange" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الجنس</label>
            <Dropdown v-model="gender" :options="genderList" showClear optionLabel="title" placeholder="الجنس" @change="onFilterChange" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>وضع الدراسة</label>
            <Dropdown v-model="studyModeFilter" :options="studyModeFilterOptions" showClear optionLabel="title" placeholder="الكل" @change="onFilterChange" />
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-12">
          <div class="d-flex">
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">Excel</label>
              <button class="btn btn-success px-3" @click="exportToExcel"><i class="pi pi-file-excel"></i></button>
            </div>
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">PDF</label>
              <button class="btn btn-danger px-3" type="button" :disabled="printing" @click="printStudents">
                <i class="pi pi-spin pi-spinner" v-if="printing"></i>
                <i class="pi pi-file-pdf" v-else></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row reservation-table">
      <div id="reservationTable" class="a4">
        <div class="first-screen-pdf">
          <h1>كشوفات طلاب</h1>
          <h2>{{ grade?.name ?? '' }}</h2>
          <h3>{{ gender?.id === 1 ? 'بنين' : gender?.id === 2 ? 'بنات' : '' }} ( {{ pagination }} )</h3>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                <input type="checkbox" :checked="allSelectedOnPage" :disabled="reservations.data.length === 0" @change="toggleSelectAll($event.target.checked)">
              </th>
              <th>#</th>
              <th>رقم حجز الطالب</th>
              <th>
                <span @click="sortByName" class="d-flex align-items-center fw-bold gap-2 p-0 m-0" style="cursor:pointer">
                  الاسم <i :class="sortAsc ? 'pi pi-sort-alpha-down' : 'pi pi-sort-alpha-up'"></i>
                </span>
              </th>
              <!-- <th>
                <span @click="sortByDegree" class="d-flex align-items-center fw-bold gap-2 p-0 m-0" style="cursor:pointer">
                  الدرجة <i :class="sortDegree ? 'pi pi-sort-numeric-down' : 'pi pi-sort-numeric-down-alt'"></i>
                </span>
              </th> -->
              <th>رقم الطالب</th>
              <th>رقم ولي الامر</th>
              <th>الجنس</th>
              <th>التعليم</th>
              <!-- <th>العنوان</th>
              <th>الشهادة</th> -->
              <th>واتساب</th>
              <th>نوع الطالب</th>
              <th>درجة الطالب</th>
              <!-- <th>الدرجة العظمى</th> -->
              <!-- <th>صورة الشهاده</th> -->
              <th>وضع الدراسة</th>
              <th>حالة الحجز</th>
              <th>الحالة</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in reservations.data" :key="index">
              <td>
                <input type="checkbox" :checked="selectedIds.includes(r.id)" @change="toggleSelect(r.id, $event.target.checked)">
              </td>
              <td data-label="Index">{{ index + 1 }}</td>
              <td data-label="ID">{{ r.id }}</td>
              <td @click="openImageCertificate(r.certificate_image)" style="cursor: pointer" data-label="الاسم">{{ r.name }}</td>
              <!-- <td>{{ r.math_degree }}</td> -->
              <td data-label="رقم الطالب">{{ r.student_phone }}</td>
              <td  data-label="رقم ولي الامر">{{ r.parent_phone }}</td>
              <td data-label="الجنس">{{ r.gender == 1 ? 'ولد' : 'بنت' }}</td>
              <td data-label="التعليم">{{ r.education_type?.title ?? '' }}</td>
              <!-- <td>
                <span :tooltip="r.address" flow="up">{{ r.address ? r.address.slice(0,10) : '' }}</span>
              </td>
              <td>
                <Button label="الشهادة" @click="openCertificate(r.certificate_image)" v-if="r.certificate_image" />
                <span v-else>—</span>
              </td> -->
              <td data-label="واتساب">{{ r.whatsapp_number }}</td>
              <td data-label="نوع الطالب">{{ r.student_type == 1 ? 'مستجد' : r.student_type == 2 ? 'قديم' : '___' }}</td>
              <td data-label="درجة الطالب">{{ r.student_actual_grade }} / {{ r.maximum_grade }}</td>
              <!-- <td data-label="الدرجة العظمى">{{ r.maximum_grade }}</td> -->
              <!-- <td data-label="الشهادة"><Button label="الشهادة"
                @click="openImageCertificate(r.certificate_image)" /></td> -->
              <td data-label="وضع الدراسة">
                <span
                  class="status-badge status-badge--clickable"
                  :class="studyModeBadgeClass(r.study_mode)"
                  @click="openStudyModePopover($event, r, index)"
                >
                  {{ studyModeLabel(r.study_mode) }}
                  <i class="pi pi-chevron-down" style="font-size:0.55rem; margin-inline-start:0.25rem;"></i>
                </span>
              </td>
              <td data-label="حالة الحجز">
                <template v-if="r.block === 0">
                  <span v-if="r.status == 0" class="status-badge status-badge--pending">معلق</span>
                  <span v-else-if="r.status == 1" class="status-badge status-badge--accepted">مقبول</span>
                  <span v-else-if="r.status == 2" class="status-badge status-badge--rejected">مرفوض</span>
                  <span v-else-if="r.status == 3" class="status-badge status-badge--waiting">انتظار الشهادة</span>
                </template>
                <span v-else class="status-badge status-badge--blocked">محظور</span>
              </td>
              <td data-label="الحالة">
                <button class="btn btn-success mx-1" v-if="r.status != 1" :tooltip="'قبول'" flow="up" @click="changeStatus(r.id, 1, index)">
                  <i class="pi pi-check-circle"></i>
                </button>
                <button class="btn btn-danger mx-1" v-if="r.status != 2" :tooltip="'رفض'" flow="up" @click="changeStatus(r.id, 2, index)">
                  <i class="pi pi-ban"></i>
                </button>
                <button class="btn btn-warning text-white mx-1" v-if="r.status != 0" :tooltip="'تعليق'" flow="up" @click="changeStatus(r.id, 0, index)">
                  <i class="pi pi-exclamation-circle"></i>
                </button>
                <button class="btn btn-info text-white mx-1" v-if="r.status != 3" :tooltip="'انتظار شهادة'" flow="up" @click="changeStatus(r.id, 3, index)">
                  <i class="pi pi-images"></i>
                </button>
              </td>
              <td data-label="الإجراءات">
                <router-link class="btn btn-info text-white mx-1" :tooltip="'تعديل كلمة المرور'" flow="up" :to="`/update_password/${r.user_id}`">
                  <i class="pi pi-unlock"></i>
                </router-link>
                <router-link class="btn btn-primary text-white mx-1" :tooltip="'تعديل'" flow="up" :to="`/user/edit/${r.user_id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <router-link class="btn btn-secondary btn-sm mx-1" :to="`/user/edit/${r.user_id}#periodic-follow-ups`" aria-label="المتابعة الدورية للطالب"><i class="pi pi-list-check" aria-hidden="true"></i> المتابعة الدورية</router-link>
                <button :class="`btn ${r.block === 0 ? 'btn-danger' : 'btn-success'} text-white mx-1`" :tooltip="r.block === 1 ? 'إلغاء حظر' : 'حظر'" flow="up" @click="blockStudent(r.user_id)">
                  <i :class="`pi ${r.block === 0 ? 'pi-ban' : 'pi-circle'}`"></i>
                </button>
                <button class="btn btn-danger text-white mx-1" :tooltip="'حذف'" flow="up" @click="deleteReservation(r.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-10 col-12">
        <pagination :data="reservations" class="mx-auto d-flex align-items-center justify-content-center pagination" @pagination-change-page="fetchReservation">
          <template v-slot:prev-nav>&lt;</template>
          <template v-slot:next-nav>&gt;</template>
        </pagination>
      </div>
      <div class="col-md-2 col-12 mt-md-0 mt-3">
        <div class="form-group d-flex justify-content-center">
          <Dropdown v-model="per_page" :options="perPages" showClear optionLabel="title" placeholder="عدد الطلاب" @change="onFilterChange" />
        </div>
      </div>
    </div>

  </div>

  <div id="printReport" v-if="printData">
    <div class="print-report-header">
      <h1>كشوفات طلاب</h1>
      <div class="print-report-meta">
        <span><strong>الصف / العام الدراسي:</strong> {{ grade?.name ?? '—' }}</span>
        <span><strong>عدد الطلاب:</strong> {{ printData.length }}</span>
        <span><strong>تاريخ الطباعة:</strong> {{ printedAt }}</span>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>رقم حجز الطالب</th>
          <th>الاسم</th>
          <th>رقم الطالب</th>
          <th>رقم ولي الامر</th>
          <th>الجنس</th>
          <th>التعليم</th>
          <th>واتساب</th>
          <th>نوع الطالب</th>
          <th>درجة الطالب</th>
          <th>وضع الدراسة</th>
          <th>حالة الحجز</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(r, index) in printData" :key="r.id">
          <td>{{ index + 1 }}</td>
          <td>{{ r.id }}</td>
          <td>{{ r.name }}</td>
          <td>{{ r.student_phone }}</td>
          <td>{{ r.parent_phone }}</td>
          <td>{{ r.gender == 1 ? 'ولد' : 'بنت' }}</td>
          <td>{{ r.education_type?.title ?? '' }}</td>
          <td>{{ r.whatsapp_number }}</td>
          <td>{{ r.student_type == 1 ? 'مستجد' : r.student_type == 2 ? 'قديم' : '' }}</td>
          <td>{{ r.student_actual_grade }} / {{ r.maximum_grade }}</td>
          <td>{{ studyModeLabel(r.study_mode) }}</td>
          <td>
            <template v-if="r.block === 0">
              <template v-if="r.status == 0">معلق</template>
              <template v-else-if="r.status == 1">مقبول</template>
              <template v-else-if="r.status == 2">مرفوض</template>
              <template v-else-if="r.status == 3">انتظار الشهادة</template>
            </template>
            <template v-else>محظور</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <Dialog v-model:visible="visible" :dismissableMask="true" modal header="صورة الشهادة">
    <Image :src="certificateImage" alt="certificate" class="certificate_image" preview />
  </Dialog>

  <Dialog v-model:visible="bulkStatusDialogVisible" :dismissableMask="true" modal header="تغيير حالة الحجوزات" :style="{ width: '32rem' }">
    <div class="form-group d-flex flex-column mb-3">
      <label>الجنس</label>
      <Dropdown v-model="bulkGender" :options="bulkGenderOptions" optionLabel="title" class="w-100" @change="fetchBulkPreviewCount" />
    </div>
    <div class="form-group d-flex flex-column mb-3">
      <label>نوع الطالب</label>
      <Dropdown v-model="bulkStudentType" :options="bulkStudentTypeOptions" optionLabel="title" class="w-100" @change="fetchBulkPreviewCount" />
    </div>
    <div class="form-group d-flex flex-column mb-3">
      <label>الحالة الحالية *</label>
      <Dropdown v-model="bulkCurrentStatus" :options="reservationStatusList" optionLabel="title" placeholder="اختر الحالة الحالية" class="w-100" @change="onBulkCurrentStatusChange" />
    </div>
    <div class="form-group d-flex flex-column mb-3">
      <label>الحالة الجديدة *</label>
      <Dropdown v-model="bulkNewStatus" :options="bulkNewStatusOptions" optionLabel="title" placeholder="اختر الحالة الجديدة" class="w-100" :disabled="!bulkCurrentStatus" />
    </div>

    <div class="bulk-status-preview" :class="{ 'text-danger': bulkPreviewCount === 0, 'text-muted': bulkPreviewCount === null }">
      <i class="pi pi-spin pi-spinner" v-if="bulkPreviewLoading"></i>
      <span v-else-if="bulkPreviewCount === null">اختر الحالة الحالية لعرض عدد الطلاب المطابقين.</span>
      <span v-else-if="bulkPreviewCount === 0">لا يوجد طلاب مطابقون للفلاتر المحددة.</span>
      <span v-else>سيتم تحديث حالة {{ bulkPreviewCount }} طالباً.</span>
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="bulkStatusDialogVisible = false">إلغاء</button>
      <button type="button" class="btn btn-success" :disabled="bulkConfirmDisabled" @click="confirmBulkStatusUpdate">
        <i class="pi pi-spin pi-spinner-dotted" v-if="bulkUpdating"></i>
        تأكيد
      </button>
    </template>
  </Dialog>

  <Dialog v-model:visible="transferDialogVisible" :dismissableMask="!transferring" :closable="!transferring" modal header="نقل الطلاب" :style="{ width: '32rem' }">
    <div class="form-group d-flex flex-column mb-3">
      <label>عدد الطلاب المحددين</label>
      <input type="text" class="form-control" :value="selectedIds.length" readonly disabled>
    </div>
    <div class="form-group d-flex flex-column mb-3">
      <label>{{ currentYearLabels.length > 1 ? 'الصفوف الحالية' : 'الصف الحالي' }}</label>
      <input type="text" class="form-control" :value="currentYearLabels.join('، ') || '—'" readonly disabled>
    </div>
    <div class="form-group d-flex flex-column mb-3">
      <label>نقل إلى *</label>
      <Dropdown v-model="transferTargetYear" :options="transferTargetOptions" optionLabel="name" placeholder="اختر الصف الجديد" class="w-100" :disabled="transferring" />
    </div>

    <div class="bulk-status-preview text-muted">
      <span v-if="currentYearLabels.length > 1">
        سيتم نقل الطلاب المحددين من الصفوف الحالية إلى الصف المستهدف بدون حذف حجوزاتهم أو إنشاء حجوزات جديدة.
      </span>
      <span v-else>
        سيتم نقل الطلاب المحددين إلى الصف الجديد بدون حذف حجوزاتهم أو إنشاء حجوزات جديدة.
      </span>
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" :disabled="transferring" @click="transferDialogVisible = false">إلغاء</button>
      <button type="button" class="btn btn-success" :disabled="!transferTargetYear || transferring" @click="confirmTransfer">
        <i class="pi pi-spin pi-spinner-dotted" v-if="transferring"></i>
        {{ transferring ? 'جاري نقل الطلاب...' : 'تأكيد النقل' }}
      </button>
    </template>
  </Dialog>

  <Popover ref="studyModePopover">
    <div class="study-mode-popover">
      <button
        v-for="opt in studyModeOptions"
        :key="opt.value"
        type="button"
        class="study-mode-option"
        :class="[opt.badgeClass, { active: studyModeTarget?.row.study_mode === opt.value }]"
        :disabled="savingStudyMode"
        @click="selectStudyMode(opt.value)"
      >
        <span>{{ opt.label }}</span>
        <i class="pi pi-spin pi-spinner-dotted" v-if="savingStudyMode && pendingStudyModeValue === opt.value"></i>
        <i class="pi pi-check" v-else-if="studyModeTarget?.row.study_mode === opt.value"></i>
      </button>
    </div>
  </Popover>

  <Dialog v-model:visible="visible" :dismissableMask="true" modal header="صورة الشهادة">
        <Image :src="certificate_image" alt="certificate_image" class="certificate_image" preview />
        <!-- <img :src="certificate_image" class="certificate_image" alt="certificate_image"> -->
    </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Image from 'primevue/image';
import Popover from 'primevue/popover';
import pagination from 'laravel-vue-pagination';
import * as XLSX from 'xlsx/xlsx.mjs';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BulkSms from '@/components/reservation/BulkSms.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

const STUDY_MODE_OPTIONS = [
  { value: 'offline', label: 'أوفلاين فقط', shortLabel: 'أوفلاين', badgeClass: 'status-badge--offline' },
  { value: 'online', label: 'أونلاين فقط', shortLabel: 'أونلاين', badgeClass: 'status-badge--online' },
  { value: 'hybrid', label: 'أوفلاين + أونلاين', shortLabel: 'أوفلاين + أونلاين', badgeClass: 'status-badge--hybrid' },
];

// Options for the "وضع الدراسة" listing filter (separate from STUDY_MODE_OPTIONS,
// which drives the read/write per-row badge+popover and keeps its own labels).
// id: 'null' is the literal wire value the backend matches against
// study_mode IS NULL — never confused with "no filter selected" (showClear).
const STUDY_MODE_FILTER_OPTIONS = [
  { id: 'online', title: 'أونلاين فقط' },
  { id: 'offline', title: 'حضوري فقط' },
  { id: 'hybrid', title: 'أونلاين + حضوري' },
  { id: 'null', title: 'غير محدد' },
];

export default {
  name: 'GradeStudents',
  components: { Dialog, Button, Dropdown, Image, Popover, pagination, Breadcrumb, BulkSms },

  data() {
    return {
      reservations: { data: [] },
      pagination: 0,
      word: '',
      status: null,
      min_degree: 0,
      max_degree: '',
      gender: '',
      student_type: '',
      studyModeFilter: null,
      studyModeFilterOptions: STUDY_MODE_FILTER_OPTIONS,
      per_page: null,
      certificate_image: "",
      visible: false,
      printData: null,
      printedAt: '',
      printing: false,
      sortAsc: true,
      sortDegree: true,
      orderByName: true,
      orderByDegree: false,
      searchTimeout: null,
      degreeTimeout: null,
      visible: false,
      certificateImage: '',
      studyModeOptions: STUDY_MODE_OPTIONS,
      studyModeTarget: null, // { row, index }
      savingStudyMode: false,
      pendingStudyModeValue: null,
      statusList: [
        { id: 0, title: 'معلق' },
        { id: 1, title: 'مقبول' },
        { id: 2, title: 'مرفوض' },
        { id: 3, title: 'في انتظار الشهادة' },
        { id: 6, title: 'محظور' },
      ],
      genderList: [
        { id: 1, title: 'ولد' },
        { id: 2, title: 'بنت' },
      ],
      studentTypeList: [
        { id: 'new', title: 'مستجد' },
        { id: 'old', title: 'قديم' },
      ],
      perPages: [
        { title: 'الكل', id: 10000 },
        { title: 10, id: 10 },
        { title: 25, id: 25 },
        { title: 50, id: 50 },
        { title: 100, id: 100 },
      ],

      // Bulk Status Update dialog
      bulkStatusDialogVisible: false,
      reservationStatusList: [],
      bulkGenderOptions: [
        { id: null, title: 'الكل' },
        { id: 1, title: 'أولاد' },
        { id: 2, title: 'بنات' },
      ],
      bulkGender: null,
      bulkStudentTypeOptions: [
        { id: null, title: 'الكل' },
        { id: 'new', title: 'مستجد' },
        { id: 'old', title: 'قديم' },
      ],
      bulkStudentType: null,
      bulkCurrentStatus: null,
      bulkNewStatus: null,
      bulkPreviewCount: null,
      bulkPreviewLoading: false,
      bulkPreviewTimeout: null,
      bulkUpdating: false,

      // Bulk Student Transfer — row selection is page-scoped (IDs are actual
      // reservation ids, never table row indexes) and is cleared on every
      // filter/page/pagination change since a selected id may no longer be visible.
      selectedIds: [],
      currentPage: 1,
      transferDialogVisible: false,
      transferTargetYear: null,
      transferring: false,
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },
    gradeSlug() { return this.$route.params.gradeSlug; },
    grade() {
      return this.gradeStore.activeGrades.find(g => g.slug === this.gradeSlug)
          || this.gradeStore.allGrades.find(g => g.slug === this.gradeSlug)
          || null;
    },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.grade?.name ?? 'المرحلة', path: `/grades/${this.gradeSlug}/students` },
      ];
    },
    bulkNewStatusOptions() {
      if (!this.bulkCurrentStatus) return this.reservationStatusList;
      return this.reservationStatusList.filter(s => s.id !== this.bulkCurrentStatus.id);
    },
    bulkConfirmDisabled() {
      return !this.bulkCurrentStatus || !this.bulkNewStatus || this.bulkPreviewLoading || !this.bulkPreviewCount;
    },

    allSelectedOnPage() {
      return this.reservations.data.length > 0
        && this.reservations.data.every(r => this.selectedIds.includes(r.id));
    },

    // Distinct academic_year_id values among the SELECTED rows currently on
    // this page — computed from the actual reservation data (never assumed
    // from the page/grade context), so it stays correct even if selection
    // somehow spans more than one academic year.
    selectedCurrentYearIds() {
      const ids = new Set();
      for (const r of this.reservations.data) {
        if (this.selectedIds.includes(r.id) && r.academic_year_id) ids.add(r.academic_year_id);
      }
      return Array.from(ids);
    },

    currentYearLabels() {
      const names = new Set();
      for (const r of this.reservations.data) {
        if (this.selectedIds.includes(r.id) && r.academic_year_name) names.add(r.academic_year_name);
      }
      return Array.from(names);
    },

    // Target dropdown: every active academic year EXCEPT whichever one(s) the
    // selected students are already in — dynamic, never hard-coded ids/names.
    transferTargetOptions() {
      const currentIds = new Set(this.selectedCurrentYearIds);
      return this.gradeStore.activeGrades.filter(g => !currentIds.has(g.id));
    },
  },

  methods: {
    debounceFetch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchReservation(), 1500);
    },

    // Separate timer from debounceFetch so typing in the degree fields never
    // cancels/resets a pending search debounce (or vice versa).
    debounceFetchByDegree() {
      clearTimeout(this.degreeTimeout);
      this.degreeTimeout = setTimeout(() => this.fetchReservation(), 1000);
    },

    openImageCertificate(certificate_image) {
      this.certificate_image = certificate_image;
      this.visible = true
    },

    buildFilterFormData() {
      const fd = new FormData();

      if (this.grade?.id) {
        fd.append('academic_year_id', this.grade.id);
      }

      if (this.word) fd.append('word', this.word);
      if (this.status?.id === 6) {
        fd.append('is_block', 1);
      } else if (this.status !== null && this.status !== undefined) {
        fd.append('status', this.status.id);
      }
      if (this.min_degree) fd.append('min_degree', this.min_degree);
      if (this.max_degree) fd.append('max_degree', this.max_degree);
      if (this.gender) fd.append('gender', this.gender.id);
      if (this.student_type) fd.append('student_type', this.student_type.id);
      if (this.studyModeFilter) fd.append('study_mode', this.studyModeFilter.id);
      if (this.orderByName) fd.append('order_by_name', 1);
      if (this.orderByDegree) fd.append('order_by_degree', 1);

      return fd;
    },

    fetchReservation(page = 1) {
      const pageNumber = Number.isInteger(page) ? page : (parseInt(page, 10) || 1);
      const perPageValue = this.per_page?.id ?? 10;
      this.currentPage = pageNumber;
      // Selection is page-scoped: any previously selected ids that are no
      // longer part of the freshly loaded page/filters must not linger.
      this.selectedIds = [];

      axios.post(`/all_reservations?page=${pageNumber}&per_page=${perPageValue}`, this.buildFilterFormData())
        .then(({ data }) => {
          this.reservations = data.data;
          this.pagination = data.data.meta.total;
        })
        .catch(() => { this.reservations = { data: [] }; });
    },
    onFilterChange() {
      this.fetchReservation(1);
    },

    toggleSelect(id, checked) {
      if (checked) {
        if (!this.selectedIds.includes(id)) this.selectedIds.push(id);
      } else {
        this.selectedIds = this.selectedIds.filter(x => x !== id);
      }
    },

    toggleSelectAll(checked) {
      this.selectedIds = checked ? this.reservations.data.map(r => r.id) : [];
    },

    openTransferDialog() {
      if (this.selectedIds.length === 0) return;
      this.transferTargetYear = null;
      this.transferDialogVisible = true;
    },

    confirmTransfer() {
      if (!this.transferTargetYear || this.transferring || this.selectedIds.length === 0) return;
      this.transferring = true;

      axios.post('/reservations/bulk-transfer', {
        reservation_ids: this.selectedIds,
        academic_year_id: this.transferTargetYear.id,
      }).then(({ data }) => {
        if (data.status) {
          this.transferDialogVisible = false;
          this.selectedIds = [];
          this.fetchReservation(this.currentPage);
          const toast = Swal.mixin({
            toast: true, position: 'top-end',
            showConfirmButton: false, timer: 3000, timerProgressBar: true,
          });
          toast.fire({ icon: 'success', title: data.message || `تم نقل ${data.transferred_count} طلاب بنجاح` });
        } else {
          this.showTransferError(data);
        }
      }).catch((error) => {
        this.showTransferError(error.response?.data);
      }).finally(() => {
        this.transferring = false;
      });
    },

    showTransferError(data) {
      const conflicts = data?.conflicts;
      if (Array.isArray(conflicts) && conflicts.length) {
        const list = conflicts.map(c => `- ${c.name} — رقم الحجز ${c.reservation_number}`).join('<br>');
        Swal.fire({
          title: 'تم إيقاف عملية النقل',
          html: `${data.message || ''}<br><br>${list}`,
          icon: 'error',
        });
      } else {
        Swal.fire('', data?.message || 'لا يمكن نقل الطلاب المحددين', 'error');
      }
    },

    async printStudents() {
      if (this.printing) return;
      this.printing = true;
      try {
        // Fetch every matching row (not just the current page) so the report
        // is complete whether there are 10 or 500 students. per_page is sent
        // explicitly in the URL (same mechanism as fetchReservation) instead of
        // the old global default header, which could be overwritten/reset by
        // any other in-flight request before this one actually fired.
        const { data } = await axios.post('/all_reservations?page=1&per_page=100000', this.buildFilterFormData());
        this.printData = data.data.data;
        this.printedAt = new Date().toLocaleString('ar-EG', { dateStyle: 'full', timeStyle: 'short' });
        await this.$nextTick();
        window.print();
      } catch (err) {
        Swal.fire('', 'تعذر تجهيز التقرير للطباعة', 'error');
      } finally {
        this.printing = false;
      }
    },

    changeStatus(id, status, index) {
      const labels = { 0: 'تعليق', 1: 'قبول', 2: 'رفض', 3: 'انتظار الشهادة' };
      Swal.fire({
        title: `تحويل إلى: ${labels[status]}؟`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: labels[status],
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('reservation_id', id);
        fd.append('status', status);
        axios.post('/change_reservation_status', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.reservations.data[index].status = status;
          }
        });
      });
    },

    async openBulkStatusDialog() {
      if (!this.grade?.id) return;
      this.bulkGender = this.bulkGenderOptions[0];
      this.bulkStudentType = this.bulkStudentTypeOptions[0];
      this.bulkCurrentStatus = null;
      this.bulkNewStatus = null;
      this.bulkPreviewCount = null;
      this.bulkStatusDialogVisible = true;
      if (!this.reservationStatusList.length) {
        await this.fetchReservationStatuses();
      }
    },

    async fetchReservationStatuses() {
      try {
        const { data } = await axios.get('/reservation_statuses');
        this.reservationStatusList = data.data ?? [];
      } catch {
        this.reservationStatusList = [];
      }
    },

    onBulkCurrentStatusChange() {
      // A previously selected "new status" may now equal the new "current status" — clear it.
      if (this.bulkNewStatus && this.bulkCurrentStatus && this.bulkNewStatus.id === this.bulkCurrentStatus.id) {
        this.bulkNewStatus = null;
      }
      this.fetchBulkPreviewCount();
    },

    fetchBulkPreviewCount() {
      clearTimeout(this.bulkPreviewTimeout);
      if (!this.bulkCurrentStatus) {
        this.bulkPreviewCount = null;
        return;
      }
      this.bulkPreviewLoading = true;
      this.bulkPreviewTimeout = setTimeout(async () => {
        try {
          const { data } = await axios.post('/bulk_update_reservation_status_preview', {
            academic_year_id: this.grade.id,
            gender: this.bulkGender?.id || undefined,
            student_type: this.bulkStudentType?.id || undefined,
            current_status: this.bulkCurrentStatus.id,
          });
          this.bulkPreviewCount = data.count ?? 0;
        } catch {
          this.bulkPreviewCount = 0;
        } finally {
          this.bulkPreviewLoading = false;
        }
      }, 300);
    },

    confirmBulkStatusUpdate() {
      if (this.bulkConfirmDisabled) return;
      const genderLabel = this.bulkGender?.id ? this.bulkGender.title : 'الكل';
      const studentTypeLabel = this.bulkStudentType?.id ? this.bulkStudentType.title : 'الكل';

      Swal.fire({
        title: 'تأكيد تغيير الحالة',
        icon: 'warning',
        html: `
          <p>سيتم تغيير حالة جميع الطلاب المطابقين للفلاتر المحددة.</p>
          <p><strong>الحالة الحالية:</strong> ${this.bulkCurrentStatus.title}</p>
          <p><strong>الحالة الجديدة:</strong> ${this.bulkNewStatus.title}</p>
          <p><strong>الجنس:</strong> ${genderLabel}</p>
          <p><strong>نوع الطالب:</strong> ${studentTypeLabel}</p>
          <p><strong>عدد الطلاب:</strong> ${this.bulkPreviewCount}</p>
        `,
        showCancelButton: true,
        confirmButtonText: 'تأكيد',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        this.bulkUpdating = true;
        axios.post('/bulk_update_reservation_status', {
          academic_year_id: this.grade.id,
          gender: this.bulkGender?.id || undefined,
          student_type: this.bulkStudentType?.id || undefined,
          current_status: this.bulkCurrentStatus.id,
          new_status: this.bulkNewStatus.id,
        }).then(({ data }) => {
          if (data.status) {
            this.bulkStatusDialogVisible = false;
            this.fetchReservation();
            const toast = Swal.mixin({
              toast: true, position: 'top-end',
              showConfirmButton: false, timer: 3000, timerProgressBar: true,
            });
            toast.fire({ icon: 'success', title: `تم تحديث حالة ${data.updated_count} طالباً بنجاح.` });
          } else {
            Swal.fire('', data.message, 'error');
          }
        }).catch((error) => {
          Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء تحديث الحالة', 'error');
        }).finally(() => {
          this.bulkUpdating = false;
        });
      });
    },

    deleteReservation(id) {
      Swal.fire({
        title: 'حذف الحجز؟',
        text: 'سيتم نقل الحجز إلى سلة المحذوفات ويمكن استرجاعه لاحقاً.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'حذف',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('reservation_id', id);
        axios.post('delete_reservation', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.reservations.data = this.reservations.data.filter(x => x.id !== id);
          }
        });
      });
    },

    blockStudent(userId) {
      Swal.fire({
        title: 'حظر / إلغاء حظر الطالب؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'تأكيد',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('user_id', userId);
        axios.post('toggle_block_user', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            const found = this.reservations.data.find(x => x.user_id === userId);
            if (found) found.block = found.block === 0 ? 1 : 0;
          }
        });
      });
    },

    openCertificate(src) {
      this.certificateImage = src;
      this.visible = true;
    },

    studyModeLabel(mode) {
      return this.studyModeOptions.find(o => o.value === mode)?.shortLabel
        ?? this.studyModeOptions[0].shortLabel;
    },

    studyModeBadgeClass(mode) {
      return this.studyModeOptions.find(o => o.value === mode)?.badgeClass
        ?? this.studyModeOptions[0].badgeClass;
    },

    openStudyModePopover(event, row, index) {
      this.studyModeTarget = { row, index };
      this.$refs.studyModePopover.toggle(event);
    },

    async selectStudyMode(value) {
      if (!this.studyModeTarget || this.savingStudyMode) return;
      const { row } = this.studyModeTarget;

      if (value === row.study_mode) {
        this.$refs.studyModePopover.hide();
        return;
      }

      this.savingStudyMode = true;
      this.pendingStudyModeValue = value;

      const toast = Swal.mixin({
        toast: true, position: 'top-end',
        showConfirmButton: false, timer: 2500, timerProgressBar: true,
      });

      try {
        const fd = new FormData();
        fd.append('user_id', row.user_id);
        fd.append('study_mode', value);
        const { data } = await axios.post('/update_student_study_mode', fd);

        if (data.status) {
          row.study_mode = value;
          this.$refs.studyModePopover.hide();
          toast.fire({ icon: 'success', title: data.message || 'تم تحديث وضع الدراسة بنجاح' });
        } else {
          toast.fire({ icon: 'error', title: data.message || 'تعذر تحديث وضع الدراسة' });
        }
      } catch (err) {
        toast.fire({ icon: 'error', title: err.response?.data?.message || 'تعذر تحديث وضع الدراسة' });
      } finally {
        this.savingStudyMode = false;
        this.pendingStudyModeValue = null;
      }
    },

    sortByName() {
      this.orderByName = !this.orderByName;
      this.sortAsc = !this.sortAsc;
      this.orderByDegree = false;
      this.sortDegree = true;
      this.fetchReservation();
    },

    sortByDegree() {
      this.orderByDegree = !this.orderByDegree;
      this.sortDegree = !this.sortDegree;
      this.orderByName = false;
      this.sortAsc = true;
      this.fetchReservation();
    },

    exportToExcel() {
      const table = document.getElementById('reservationTable').cloneNode(true);
      const thead = table.querySelector('thead tr');
      const removeHeaders = ['الشهادة', 'حالة الحجز', 'رقم الطالب', 'الجنس', 'العنوان', 'التحكم', 'الحالة', ''];
      const headers = Array.from(thead.children);
      const removeIdx = headers.map((th, i) => removeHeaders.includes(th.textContent.trim()) ? i : -1).filter(i => i !== -1);
      removeIdx.sort((a, b) => b - a).forEach(i => thead.removeChild(headers[i]));
      table.querySelectorAll('tbody tr').forEach(row => {
        removeIdx.forEach(i => { if (row.children[i]) row.removeChild(row.children[i]); });
      });
      const ws = XLSX.utils.table_to_sheet(table);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.grade?.name ?? 'students'}.xlsx`);
    },
  },

  async mounted() {
    // Ensure grades are loaded so grade info is available
    if (!this.gradeStore.activeGrades.length) {
      await this.gradeStore.fetchActiveGrades();
    }
    if (!this.gradeStore.allGrades.length) {
      await this.gradeStore.fetchAllGrades();
    }
    this.fetchReservation();
  },
};
</script>

<style scoped>
#printReport { display: none; }
</style>

<style>
/* Not scoped on purpose: printing must hide the navbar/sidebar/breadcrumb
   that live outside this component's DOM (e.g. in App.vue). */
@media print {
  body * {
    visibility: hidden !important;
  }
  #printReport,
  #printReport * {
    visibility: visible !important;
  }
  #printReport {
    display: block !important;
    position: absolute;
    inset: 0;
    width: 100%;
    padding: 10mm;
  }
  #printReport .print-report-header {
    margin-bottom: 6mm;
    text-align: center;
  }
  #printReport .print-report-header h1 {
    font-size: 1.5rem;
    margin-bottom: 3mm;
  }
  #printReport .print-report-meta {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
  }
  #printReport table {
    width: 100%;
    border-collapse: collapse;
  }
  #printReport thead {
    display: table-header-group;
  }
  #printReport th,
  #printReport td {
    border: 1px solid #333;
    padding: 2mm;
    font-size: 0.75rem;
    text-align: center;
  }
  #printReport tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  @page {
    size: A4;
    margin: 10mm;
  }
}
</style>
